import {
	getMinWidth,
	SIZE_DESKTOP,
	SIZE_MOBILE,
} from "@escapio/portal/dom/screen";

const skyscraperSizes = [[200, 600]];

const leaderboardSizes = [
	[728, 180],
	[320, 150],
	[300, 150],
];
const leaderboardMapping = [
	{
		screen: [getMinWidth(SIZE_DESKTOP), 0],
		sizes: [[728, 180]],
	},
	{
		screen: [getMinWidth(SIZE_MOBILE), 0],
		sizes: [
			[300, 150],
			[320, 150],
		],
	},
];

export default {
	list_skyscraper: {
		sizes: skyscraperSizes,
	},
	profile_skyscraper: {
		sizes: skyscraperSizes,
	},
	list_leaderboard_1: {
		sizes: leaderboardSizes,
		sizeMap: leaderboardMapping,
	},
	list_leaderboard_2: {
		sizes: leaderboardSizes,
		sizeMap: leaderboardMapping,
	},
};
